import { Popper, PopperProps } from '@mui/material';
import { ReactNode } from 'react';

interface EqlFieldValuesAutoCompletePopperProps extends PopperProps {
  renderFooter?: () => ReactNode;
}

export function EqlFieldValuesAutoCompletePopper({
  renderFooter,
  ...props
}: EqlFieldValuesAutoCompletePopperProps) {
  return (
    <Popper
      {...props}
      placement="bottom-start"
      modifiers={[{ name: 'flip', enabled: false }]}
    >
      <>
        {props.children}
        {renderFooter?.()}
      </>
    </Popper>
  );
}
